import styled from 'styled-components';
import { FormEvent, useCallback, useState } from 'react';
import {
  Tab,
  useTabsActions,
} from '@paradigm/features/src/unified-rfqs/ui/rfq-filters/tabs-context';
import BaseModal, {
  Body,
  CloseButton,
  Footer as BaseFooter,
  Header as BaseHeader,
} from '@paradigm/design-system/src/components/Modal';
import Button from '@paradigm/design-system/src/components/Button';
import Input from '@paradigm/design-system/src/components/Input';

interface Props {
  readonly tab: Tab;
  readonly isOpen: boolean;
  readonly close: () => void;
}

export default function RenameTabModal({ tab, isOpen, close }: Props) {
  const [tabName, setTabName] = useState(tab.name);
  const { setTab } = useTabsActions();

  const save = useCallback(() => {
    const updatedTab: Tab = {
      ...tab,
      name: tabName,
    };
    setTab(updatedTab);
    close();
  }, [close, setTab, tab, tabName]);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    save();
  };

  return (
    <Modal width={400} isOpen={isOpen} data-testid="rename-tab-modal">
      <Header>
        Rename
        <CloseButton onClick={close} />
      </Header>
      <Body>
        <form onSubmit={handleSubmit}>
          <Input
            id="rename-tab-name-input"
            label="Name"
            inputType="text"
            value={tabName}
            onChange={setTabName}
          />
        </form>
      </Body>
      <Footer>
        <Button ariaLabel="save" onClick={save}>
          Save
        </Button>
      </Footer>
    </Modal>
  );
}

const Modal = styled(BaseModal).attrs({ isFullScreenMobile: false })`
  max-width: 80vw;

  .modal-content {
    padding: 1rem;
  }
`;

const Header = styled(BaseHeader)`
  padding: 0;
  padding-bottom: 1rem;
`;

const Footer = styled(BaseFooter)`
  padding: 0;
`;
